import { Modal } from '../modal/Modal';
import { getFullSurveyList } from '../../utils/utils';
import { FaCheck, FaTimes } from 'react-icons/fa';
import styled, { css } from 'styled-components';

export interface ModalSubmitEntityErrorsProps {
  entity: any;
  show?: boolean;
  onClose: () => void;
  onClick: () => void;
}

export const ModalSubmitEntityErrors = ({ entity, show, onClose, onClick }: ModalSubmitEntityErrorsProps) => {
  return (
    <>
      {show && (
        <Modal onClose={onClose} size={{ height: undefined, width: '40%' }} show={show} title={'Réponses manquantes'}>
          <ConformityErrorsSummary>
            <ErrorTitle>
              Certaines des réponses pour <b>{entity?.name}</b> sont manquantes
            </ErrorTitle>
            <Slider>
              <ErrorList>
                {getFullSurveyList(entity)
                  .filter(survey => survey.fillingPercentage !== 100 && !Number.isNaN(survey.fillingPercentage)) //If not created, versionable surveys returns NaN
                  .map((surveyItem, index) => (
                    <ErrorItem key={index}>
                      <SurveyName>{surveyItem.name}</SurveyName>
                      <span>
                        questions obligatoires:{' '}
                        <b>
                          {surveyItem.filledRequiredQuestions} / {surveyItem.requiredQuestions.amount}
                        </b>
                      </span>
                    </ErrorItem>
                  ))}
              </ErrorList>
            </Slider>
            <ErrorTitle>Etes-vous sûr de vouloir soumettre les réponses pour cette entité malgré tout ? </ErrorTitle>
            <ErrorsActions>
              <Action enabled={true} onClick={onClose}>
                <Label>Annuler</Label>
                <FaTimes style={{ color: '#ff7675' }} />
              </Action>
              <Action enabled={true} onClick={onClick}>
                <Label>Valider</Label>
                <FaCheck style={{ color: '#55efc4' }} />
              </Action>
            </ErrorsActions>
          </ConformityErrorsSummary>
        </Modal>
      )}
    </>
  );
};

const ConformityErrorsSummary = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: calc(100% - 40px);
  padding: 20px;
  min-height: 0;
  row-gap: 20px;
`;

const Slider = styled.div`
  overflow-y: auto;
  flex: 1;
`;

const ErrorList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  row-gap: 10px;
`;

const ErrorTitle = styled.div`
  font-size: 1.2em;
  text-align: center;

  b {
    color: #1179a0;
  }
`;

const ErrorItem = styled.div`
  display: flex;
  border: 1px solid #dfe6e9;
  padding: 5px;
  margin: 0 10px;

  border-radius: 5px;
  flex-direction: column;
  line-height: 20px;

  span {
    color: #797979;

    b {
      color: #ff7675;
    }
  }
`;

const ErrorsActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 50px;
`;

const Action = styled.div<{ enabled: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${({ enabled }) => (enabled ? 0.8 : 0.4)};
  transition: opacity 0.2s;
  user-select: none;

  cursor: ${({ enabled }) => (enabled ? 'pointer' : 'not-allowed')};

  ${({ enabled }) =>
    enabled &&
    css`
      &:hover {
        opacity: 1;
      }
    `}
  svg {
    height: 20px;
    width: 20px;
  }
`;

const Label = styled.span``;

const SurveyName = styled.div``;
